import React from "react";
import { Link } from "react-router-dom";

/**
 * Bouton pleine largeur de la carte. `charge` affiche le rond de chargement et
 * désactive le bouton ; `to` rend un lien routeur avec le même habillage.
 */
const Bouton = ({
  children,
  type = "button",
  secondaire = false,
  charge = false,
  disabled = false,
  onClick,
  to,
  className = "",
}) => {
  const classes = ["bouton", secondaire ? "secondaire" : "", charge ? "charge" : "", className]
    .filter(Boolean)
    .join(" ");

  if (to) {
    return (
      <Link to={to} className={classes}>
        {children}
      </Link>
    );
  }
  return (
    <button
      type={type}
      className={classes}
      disabled={disabled || charge}
      onClick={onClick}
      aria-busy={charge || undefined}
    >
      {charge && <span className="spin" aria-hidden="true" />}
      <span>{children}</span>
    </button>
  );
};

export default Bouton;
